import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import { AllItemSort, getPayload } from "../../store/actions";
import endPoints from "../../store/utils/endPoints";
import TableSkeleton from "../Loader/TableSkeleton";
import { numberWithCommas } from "../../utils/misc";
import nftDetailsStyles from "./scss/nft-details.module.scss";
import { isEqual } from "lodash";
const Mint = ({ timeFrame }) => {
  const dispatch = useDispatch();
  const { topMints } = useSelector((state) => state.nft);
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [queryParams, setQueryParams] = useState({});

  useEffect(() => {
    if (!topMints) {
      dispatch(
        getPayload(`${endPoints.topMints}`, {
          ...queryParams,
          range: timeFrame,
          page: pageNo,
        })
      );
    }
  }, [timeFrame]);

  useEffect(() => {
    if (topMints && topMints.message) {
      dispatch(
        AllItemSort(
          endPoints.topMints,
          [...topMints.message],
          sortField,
          sortType || false,
          sortField == "first_mint"
        )
      );
    }
  }, [queryParams]);

  const handleSortChange = (field, type) => {
    setSortField(field);
    setSortType(type);
    setQueryParams({
      range: timeFrame,
      [field]: type,
    });
  };

  const changePage = useCallback(
    (value) => {
      setPageNo(value);
    },
    [pageNo]
  );

  return (
    <>
      <table className={nftDetailsStyles.table}>
        <thead>
          <tr>
            <th>Collection</th>
            <th
              onClick={() =>
                handleSortChange("minted", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Minted{" "}
              <i
                className={`fa-solid ${
                  sortField === "minted"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "mint_volume",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Mint Volume{" "}
              <i
                className={`fa-solid ${
                  sortField === "mint_volume"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("minters", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Minters{" "}
              <i
                className={`fa-solid ${
                  sortField === "minters"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "total_gas",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Total Gas{" "}
              <i
                className={`fa-solid ${
                  sortField === "total_gas"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "first_mint",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              First Mint{" "}
              <i
                className={`fa-solid ${
                  sortField === "first_mint"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            {/* <th
              onClick={() =>
                handleSortChange("fomo", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              FOMO{" "}
              <i
                className={`fa-solid ${
                  sortField === "fomo"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th> */}
          </tr>
        </thead>
        <tbody>
          {!topMints ? (
            <TableSkeleton colSpan={7} />
          ) : (
            topMints.message.map((element) => (
              <tr>
                <td>
                  {/* <div className="token-thumb mr-3">
                    <img
                      src={element?.nft_details?.collection_image_url || "N/A"}
                      alt=""
                    />
                  </div> */}
                  <label>
                    <a href="">{element.name}</a>
                    <span>{element.symbol}</span>
                  </label>
                </td>
                <td>{element.minted && element.minted}</td>
                <td>{element.mint_volume && element.mint_volume}</td>
                <td>{element.minters && element.minters}</td>
                <td>{element.total_gas && element.total_gas}</td>
                <td>{element.first_mint}</td>
                {/* <td className="brand-success">{element.fomo}</td> */}
              </tr>
            ))
          )}
        </tbody>
      </table>
      {/* {topMints && (
        <Pagination
          totalPages={Math.ceil(topMints.total / topMints.page_size)}
          setPage={changePage}
        />
      )} */}
    </>
  );
};

export default React.memo(Mint, isEqual);
